
import { Component, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-expanded-view-slider',
    imports: [FormsModule],
    templateUrl: './expanded-view-slider.component.html',
    styleUrls: ['./expanded-view-slider.component.scss']
})
export class ExpandedViewSliderComponent {
  readonly expandView = model(false);
  readonly updateTableColumns = output<boolean>();

  updateColumns(expandView: boolean) {
    this.updateTableColumns.emit(expandView)
  }
}
